import { css, withTheme } from '@emotion/react';
import { useContext, PureComponent, ComponentClass, Component } from 'react';
import Discover from '../../common/redux/actions/DiscoverActions';
import MainActions from '../../common/redux/actions/MainActions';
import {
  NavWithLeftMargin,
  NavItemFullWidth,
  DiscoveryToolbarNavbar,
  SaveDropdownStyles,
  ToolbarDropdownRoot,
  LeftNav,
} from './discovery-toolbar.styles';
import _, { includes, isFunction } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { USE_FISCAL_REPORTING, VIZ_OPTION_IDS } from '../../common/Constants';
import { Viz } from '../VizUtil';
import { ChartSpecs } from '../ChartSpecs';
import {
  getIsReadOnlyUser,
  isAdmin,
  isPrivate,
  isUserOwnerOfDiscoveryViz,
} from '../../common/redux/selectors/AccountSelectors';
import { createSelector } from 'reselect';
import {
  VIZ_SELECTORS,
  getAllowedTabs,
  getConfigPanelDetail,
} from '../../common/redux/selectors/viz-selectors';
import { ACCOUNT_SELECTORS } from '../../common/redux/selectors/AccountSelectors';
import {
  IUserPreferencesMutationInputProps,
  UserPreferencesMutation,
} from '../../account/graphql';
import Account from '../../common/redux/actions/AccountActions';
import { messages } from '../../i18n';
import { FormGroup, FormControlLabel } from '@mui/material';
import {
  ISugarIconProps,
  DownChevron,
  ReportIcon,
  InfoFillIcon,
} from '../../icons';
import styled from '@emotion/styled';
import { IDiscoverEmotionTheme } from '../../common/emotion';

import {
  CheckIconSmall,
  FormatIcon,
  PinIcon,
  SaveIcon,
  ShareIcon,
  UndoIcon as UndoIconUnstyled,
  RedoIcon as RedoIconUnstyled,
  RefreshIcon as RefreshIconUnstyled,
} from '../../icons/icons/icons.component';
import classnames from 'classnames';
import { useExportToExcel } from '../../common/utilities/export-to-excel';
import { useHiddenFieldWarnings } from '../../common/redux/selectors/viz-selector.hook';
import { WorkerRefContext } from '../../common/utilities/web-worker';
import { IconDropdown } from '../../components/icon-dropdown';
import { DisableClickMenuItem } from '../../common/widgets/menu-items/disable-click-menu-item/disable-click-menu-item.component';
import Divider from '@mui/material/Divider';
import { ToastHOC } from '../../components/toast/toast-launcher';
import {
  IDiscoveryToolbarDispatchProps,
  IDiscoveryToolbarMapStateProps,
  IDiscoveryToolbarOwnProps,
  IDiscoveryToolbarProps,
  IDiscoveryToolbarState,
} from './discovery-toolbar.interfaces';
import moment from 'moment';
import { IDiscovery, IRevision } from '../interfaces';
import { Switch } from '../../components/switch';
import { DiscoveryToolbarButton } from './discovery-toolbar-button';
import { Tabs } from '@mui/material';

const ActionItemIconCss = css`
  padding-left: 4px;
  padding-right: 4px;
`;
const UndoIcon = props => (
  <UndoIconUnstyled css={ActionItemIconCss} {...props} />
);
const RedoIcon = props => (
  <RedoIconUnstyled css={ActionItemIconCss} {...props} />
);
const RefreshIcon = props => (
  <RefreshIconUnstyled css={ActionItemIconCss} {...props} />
);

const SaveIconWithPointerControl = styled(SaveIcon)`
  pointer-events: ${(
    props: Omit<ISugarIconProps, 'icon'> & { isSaveIconDisabled: boolean },
  ) => (props.isSaveIconDisabled ? 'none' : 'all')};
`;

class SaveAsDropdown extends PureComponent<{
  saveDisabled: boolean;
  onSave: () => void;
  onSaveVersion: () => void;
  onSaveAs: () => void;
  isNewViz: boolean;
  isDirty: boolean;
  isUserOwner: boolean;
  isReadOnlyUser: boolean;
  canSaveVersion: boolean;
}> {
  state;
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }
  render() {
    const {
      saveDisabled,
      onSave,
      onSaveVersion,
      onSaveAs,
      isNewViz,
      isReadOnlyUser,
      canSaveVersion,
    } = this.props;

    const isSaveIconDisabled = (isNewViz && saveDisabled) || isReadOnlyUser;
    const isSaveVersionDisabled = !canSaveVersion;
    return (
      <ToolbarDropdownRoot className='save-as-dropdown'>
        <span
          title={messages.discoveryToolbar.saveTooltip}
          className={classnames('dropdown-save-icon', {
            disabled: saveDisabled,
          })}
          onClick={e => {
            if (!saveDisabled) {
              e.stopPropagation();
              onSave();
            }
          }}
        >
          <SaveIconWithPointerControl
            isSaveIconDisabled={isSaveIconDisabled}
            hover={!saveDisabled}
            disabled={saveDisabled}
          />
        </span>
        <IconDropdown
          id={'save-as-dropdown'}
          onOpen={() => {
            this.setState({ isMenuOpen: true });
          }}
          onClose={() => {
            this.setState({ isMenuOpen: false });
          }}
          iconSize={12}
          IconComponent={DownChevron}
        >
          <DisableClickMenuItem
            key={'save'}
            disabled={saveDisabled}
            onClick={onSave}
          >
            {messages.discoveryToolbar.saveMenuItem}
          </DisableClickMenuItem>
          <DisableClickMenuItem
            key={'saveVersion'}
            disabled={isSaveVersionDisabled}
            onClick={onSaveVersion}
          >
            {messages.discoveryToolbar.saveVersionMenuItem}
          </DisableClickMenuItem>
          <DisableClickMenuItem
            key={'saveAs'}
            disabled={isNewViz}
            onClick={onSaveAs}
          >
            {messages.discoveryToolbar.saveAsMenuItem}
          </DisableClickMenuItem>
        </IconDropdown>
      </ToolbarDropdownRoot>
    );
  }
}

export const ExportImageMenuItem = ({
  vizId,
  exportEnabled,
  onDownload,
  vizIsEmpty,
  chartIsValid,
  shouldExportAsExcel = false,
}) => {
  const { isBlocked } = useHiddenFieldWarnings({ discoveryId: vizId });
  const disabled =
    vizIsEmpty ||
    !exportEnabled ||
    !chartIsValid ||
    shouldExportAsExcel ||
    isBlocked;
  return (
    <DisableClickMenuItem
      id={'image-export-menu-item'}
      key='download'
      title={
        !exportEnabled ? messages.discoveryToolbar.enableLiveQuery : undefined
      }
      onClick={onDownload}
      disabled={disabled}
    >
      {messages.discoveryToolbar.exportAsImageMenuItem}
    </DisableClickMenuItem>
  );
};

export const ExportExcelMenuItem = ({
  exportEnabled,
  vizId,
  vizIsEmpty,
  chartIsValid,
  chartType,
}) => {
  const { exportToExcel = _.noop, workerId } = useExportToExcel({
    vizId,
  });
  const { isBlocked } = useHiddenFieldWarnings({ discoveryId: vizId });

  const { getWorkerMeta } = useContext(WorkerRefContext);
  const { isExporting: excelReportExporting = false } = getWorkerMeta(workerId);
  const excelExportDisabledReportTypes = [
    ChartSpecs.funnel.id,
    ChartSpecs.pipeline_changes.id,
    ChartSpecs.waterfall.id,
  ];
  const disabled =
    vizIsEmpty ||
    includes(excelExportDisabledReportTypes, chartType) ||
    !chartIsValid ||
    !exportEnabled ||
    excelReportExporting ||
    isBlocked;
  return (
    <DisableClickMenuItem
      id='excel-export-menu-item'
      key='export'
      title={
        !exportEnabled ? messages.discoveryToolbar.enableLiveQuery : undefined
      }
      onClick={exportToExcel}
      disabled={disabled}
    >
      {messages.formatString(
        messages.discoveryToolbar.exportToExcelMenuItem,
        messages.nonTranslated.excel,
      )}
    </DisableClickMenuItem>
  );
};

class ShareDropdownClass extends PureComponent<{
  onCopyLink: () => void;
  onChangeAccess: (accessType: string) => void;
  onDownload: () => void;
  vizId: string;
  isDisabled: boolean;
  chartIsValid: boolean;
  isNewViz: boolean;
  isPrivate: boolean;
  isUserOwner: boolean;
  vizIsEmpty: boolean;
  exportEnabled: boolean;
  theme?: IDiscoverEmotionTheme;
  shouldExportAsExcel?: boolean;
  chartType: string;
}> {
  state;

  constructor(props) {
    super(props);
  }
  render() {
    const {
      onCopyLink,
      onChangeAccess,
      onDownload,
      isDisabled,
      chartIsValid,
      isNewViz,
      isPrivate: isDropdownPrivate,
      isUserOwner,
      vizIsEmpty,
      exportEnabled,
      shouldExportAsExcel = false,
    } = this.props;

    return (
      <ToolbarDropdownRoot className='share-dropdown'>
        <ShareIcon disabled={isDisabled} />
        <IconDropdown
          id={'share-dropdown-dropdown'}
          onOpen={() => {
            this.setState({ isMenuOpen: true });
          }}
          onClose={() => {
            this.setState({ isMenuOpen: false });
          }}
          iconSize={12}
          IconComponent={DownChevron}
        >
          <DisableClickMenuItem
            key={'copyLink'}
            onClick={onCopyLink}
            disabled={isNewViz}
          >
            {messages.discoveryToolbar.copyLinkMenuItem}
          </DisableClickMenuItem>
          <ExportExcelMenuItem
            exportEnabled={exportEnabled}
            chartIsValid={chartIsValid}
            vizId={this.props.vizId}
            vizIsEmpty={vizIsEmpty}
            chartType={this.props.chartType}
          />
          <ExportImageMenuItem
            vizId={this.props.vizId}
            exportEnabled={exportEnabled}
            chartIsValid={chartIsValid}
            onDownload={onDownload}
            vizIsEmpty={vizIsEmpty}
            shouldExportAsExcel={shouldExportAsExcel}
          />
          {isUserOwner && [
            <Divider key={'divider'} />,
            <DisableClickMenuItem
              key='private'
              onClick={() => onChangeAccess('private')}
              disabled={!chartIsValid}
            >
              {isDropdownPrivate && (
                <CheckIconSmall color={this.props.theme?.colors?.Gray90} />
              )}{' '}
              {messages.formatString(
                messages.discoveryToolbar.privateMenuOption,
                <small>- {messages.discoveryToolbar.privateSubText}</small>,
              )}
            </DisableClickMenuItem>,
            <DisableClickMenuItem
              key='public'
              onClick={() => onChangeAccess('public')}
              disabled={!chartIsValid}
            >
              {!isDropdownPrivate && (
                <CheckIconSmall color={this.props.theme?.colors?.Gray90} />
              )}{' '}
              {messages.formatString(
                messages.discoveryToolbar.publicMenuOption,
                <small>- {messages.discoveryToolbar.publicSubText}</small>,
              )}
            </DisableClickMenuItem>,
          ]}
        </IconDropdown>
      </ToolbarDropdownRoot>
    );
  }
}

export const ShareDropdown: typeof ShareDropdownClass = withTheme(
  ShareDropdownClass as any,
) as any;

export class DiscoveryToolbarUnconnected extends Component<
  IDiscoveryToolbarProps,
  IDiscoveryToolbarState
> {
  state: IDiscoveryToolbarState;

  constructor(props) {
    super(props);

    const {
      useFiscalCalendar,
      useLiveQuery,
      isPinned,
      hasFiscalCalendarSetting,
    } = props;

    this.state = {
      isPinned,
      hasFiscalCalendarSetting,
      useFiscalCalendar,
      useLiveQuery,
      showLiveQueryToggle: true,
      shownInitialLiveQueryNotification: false,
      allowExports: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const stateListenIds = [
      'useFiscalCalendar',
      'useLiveQuery',
      'showLiveQueryNotification',
      'showLiveQueryToggle',
    ];
    return (
      !_.isEqual(nextProps, this.props) ||
      _.some(
        stateListenIds,
        _varName => !_.isEqual(nextState[_varName], this.state[_varName]),
      )
    );
  }

  componentDidUpdate(prevProps: IDiscoveryToolbarProps, prevState) {
    if (
      this.props.id !== prevProps.id &&
      this.props.isPinned !== prevProps.isPinned
    ) {
      // if the current viz has changed, reset the state
      this.setState({ isPinned: this.props.isPinned });
    }

    // undo/redo can change useFiscalCalendar
    const { useFiscalCalendar } = this.props;
    if (
      !_.isNil(useFiscalCalendar) &&
      this.state.useFiscalCalendar !== useFiscalCalendar
    ) {
      this.setState({ useFiscalCalendar });
    }

    // At the time of this code block authorization, there was a rendering issue related to the modal
    // presentation and the toggle's position displacement. See DSC-5588
    if (this.state.showLiveQueryToggle !== prevState.showLiveQueryToggle) {
      this.setState({ showLiveQueryToggle: true }, () => this.forceUpdate());
    }

    if (
      prevState.showLiveQueryNotification !=
        this.state.showLiveQueryNotification &&
      this.state.showLiveQueryNotification
    ) {
      this.props.showToast({
        label: messages.toast.notice,
        onClose: () => {
          this.setState({
            showLiveQueryNotification: false,
          });
        },
        children: (
          <span>{messages.discoveryToolbar.liveQueryDialogMessage}</span>
        ),
      });
    }

    const { discovery } = this.props;
    const { discovery: prevDiscovery } = prevProps;
    if (
      !_.isNil(discovery.revisionSelected) &&
      prevDiscovery.revisionSelected !== discovery.revisionSelected
    ) {
      const { updatedByName, updatedOn } = discovery.revisionSelected;
      const formattedDate = moment(updatedOn).format(this.props.dateFormat);
      const formattedTime = moment(updatedOn).format(this.props.timeFormat);
      this.props.showToast({
        label: messages.toast.notice,
        children: (
          <span>
            {messages.formatString(
              messages.discoveryToolbar.previousVersionToast,
              updatedByName,
              formattedDate,
              formattedTime,
            )}
          </span>
        ),
      });
    }
  }

  activateLeftPanel(key) {
    this.props.setConfigPanelDetail(this.props.discovery, key);
  }
  activateRightPanel(key) {
    this.props.setPanelDetail(this.props.discovery, key);
  }
  doAction(action: string) {
    const { discovery } = this.props;
    switch (action) {
      case 'save':
        this.props.onSave();
        break;
      case 'save-version':
        this.props.onSaveVersion();
        break;
      case 'undo':
        this.props.undo(discovery);
        break;
      case 'redo':
        this.props.redo(discovery);
        break;
      case 'refresh':
        this.props.refresh(discovery);
        break;
      case 'share':
        this.props.share(discovery);
        break;
      case 'public':
        this.props.setVizAccess(discovery, 'public');
        break;
      case 'private':
        this.props.setVizAccess(discovery, 'private');
        break;
      case 'save-as': {
        this.props.onSaveAs();
        break;
      }
      case 'download': {
        Viz.generateChartScreenshot(discovery?.viz?.name, this.props.theme);
        break;
      }
      case 'pin': {
        let pinned = _.get(this.props, 'userPreferences.pinnedDiscoveries', []);
        let isPinned = false;
        if (this.props.isPinned) {
          pinned = pinned.filter(id => id !== this.props.id);
        } else {
          pinned = [...pinned, this.props.id];
          isPinned = true;
        }
        this.setState({ isPinned });
        this.props.updateUserPreferences({
          pinnedDiscoveries: pinned,
        });
        break;
      }
      case 'fiscalCalendarToggle': {
        const useFiscalCalendar = !this.state?.useFiscalCalendar;

        this.setState({ useFiscalCalendar });
        this.props.setUsingFiscalCalendar(discovery, useFiscalCalendar);
        this.props.setDirtyViz(this.props.id, true);
        break;
      }
      case 'liveQueryToggle': {
        const useLiveQuery = !this.state?.useLiveQuery;

        this.setState({
          useLiveQuery,
          showLiveQueryNotification: !useLiveQuery,
        });
        this.props.setUsingLiveQuery(discovery, useLiveQuery);
        this.props.setDirtyViz(this.props.id, true);
        break;
      }
    }
  }

  // At the time of this code block authorization, there was a rendering issue related to the modal
  // presentation and the toggle's position displacement. See DSC-5588
  forceSwitchRerender() {
    this.setState({
      showLiveQueryToggle: false,
    });
  }

  renderIconItem({ name, tooltipText, hide = false, icon, disabled = false }) {
    return hide ? (
      []
    ) : (
      <DiscoveryToolbarButton
        id={`discovery-tool-bar-action-${_.kebabCase(name)}`}
        key={name}
        value={name}
        title={tooltipText}
        disabled={disabled}
        icon={icon}
      />
    );
  }

  render() {
    const { isPinned } = this.state;

    const {
      hasUndo,
      hasRedo,
      dirty,
      isPrivate,
      isNewViz,
      isUserOwner,
      discovery,
      queryResults,
      chartSpec,
      exportEnabled,
      chartIsValid,
    } = this.props;

    const shouldExportAsExcel =
      isFunction(chartSpec?.shouldDeferToExport) &&
      chartSpec?.shouldDeferToExport(queryResults);

    const isRefreshDisabled = _.isEmpty(queryResults) || !chartIsValid;
    const isSavePanelDisabled = !dirty || !(discovery?.viz?.canUpdate ?? true);
    const isSharedDisabled = (isNewViz || isPrivate) && !isUserOwner;

    const actionPanelItems = _.map(
      [
        {
          name: 'undo',
          tooltipText: messages.discoveryToolbar.undoTooltip,
          disabled: !hasUndo,
          icon: <UndoIcon hover={hasUndo} disabled={!hasUndo} />,
        },
        {
          name: 'redo',
          tooltipText: messages.discoveryToolbar.redoTooltip,
          disabled: !hasRedo,
          icon: <RedoIcon hover={hasRedo} disabled={!hasRedo} />,
        },
        {
          name: 'refresh',
          tooltipText: messages.datasets.refreshMenuItem,
          disabled: isRefreshDisabled,
          icon: (
            <RefreshIcon
              hover={!isRefreshDisabled}
              disabled={isRefreshDisabled}
            />
          ),
        },
      ],
      this.renderIconItem,
    );

    const pinPanelItems = _.map(
      [
        {
          name: 'pin',
          tooltipText: isPinned
            ? messages.discoveryToolbar.unpinTooltip
            : messages.discoveryToolbar.pinTooltip,
          disabled: isNewViz,
          icon: (
            <PinIcon size={16} hover disabled={isNewViz} pinned={isPinned} />
          ),
        },
      ],
      this.renderIconItem,
    );

    const leftPanelItems = _([
      {
        name: 'layout',
        icon: <ReportIcon />,
        tooltipText: messages.discoveryToolbar.layoutPanelIconTooltip,
      },
      {
        name: 'format',
        icon: <FormatIcon />,
        tooltipText: messages.discoveryToolbar.formatPanelIconTooltip,
      },
      {
        name: 'detail',
        icon: <InfoFillIcon size={16} />,
        tooltipText: messages.discoveryToolbar.detailPanelIconTooltip,
      },
    ])
      .intersectionBy(this.props.allowedTabs, val =>
        _.isString(val) ? val : val?.name,
      )
      .map(this.renderIconItem)
      .value();

    const minOffsetMargin = leftPanelItems.length * 56;
    const currentLeftPanelWidth = this.props.configPanelDetail
      ? this.props.leftPanelWidth
      : 0;

    const leftOffset =
      currentLeftPanelWidth > minOffsetMargin
        ? this.props.leftPanelWidth - minOffsetMargin
        : 0;

    return (
      <DiscoveryToolbarNavbar
        id='discovery-toolbar'
        className='navbar navbar-default'
      >
        <div className='container'>
          <LeftNav
            id='discovery-toolbar-left'
            value={this.props.configPanelDetail || false}
            onChange={(e, key) => this.activateLeftPanel(key)}
            sx={{
              '& .MuiTabs-indicator': {
                display: 'none',
              },
            }}
          >
            {leftPanelItems}
          </LeftNav>
          <NavWithLeftMargin
            id='discovery-toolbar-fiscal-calendar'
            leftOffset={leftOffset}
          >
            <NavItemFullWidth>
              {this.props?.hasFiscalCalendarSetting && (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        id={'fiscalCalendarSwitch'}
                        checked={!!this.state?.useFiscalCalendar}
                        color={'primary'}
                        onClick={() => this.doAction('fiscalCalendarToggle')}
                        name={'fiscalCalendarToggleChecked'}
                      />
                    }
                    label={messages.discoveryToolbar.fiscalCalendar}
                    labelPlacement={'start'}
                  />
                </FormGroup>
              )}
              {this.state.showLiveQueryToggle && (
                <FormGroup
                  title={messages.discoveryToolbar.liveQueryHint}
                  id={'liveQuerySwitchParent'}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        id={'liveQuerySwitch'}
                        checked={!!this.state?.useLiveQuery}
                        color={'primary'}
                        onClick={() => this.doAction('liveQueryToggle')}
                        name={'liveQueryToggleChecked'}
                      />
                    }
                    label={messages.discoveryToolbar.liveQueryTitle}
                    labelPlacement={'start'}
                  />
                </FormGroup>
              )}
            </NavItemFullWidth>
          </NavWithLeftMargin>

          <Tabs
            id='discovery-toolbar-actions'
            value={this.props.interactivePanelDetail || false}
            onChange={(e, key) => this.doAction(key)}
            sx={{
              '& .MuiTabs-indicator': {
                display: 'none',
              },
            }}
          >
            {actionPanelItems}

            {!this.props.isReadOnlyUser && (
              <SaveDropdownStyles className='panel-icon-dropdown'>
                <SaveAsDropdown
                  isReadOnlyUser={this.props.isReadOnlyUser}
                  saveDisabled={isSavePanelDisabled}
                  onSave={() => this.doAction('save')}
                  onSaveVersion={() => this.doAction('save-version')}
                  onSaveAs={() => this.doAction('save-as')}
                  isNewViz={this.props.isNewViz}
                  isDirty={this.props.dirty}
                  isUserOwner={this.props.isUserOwner}
                  canSaveVersion={this.props.canSaveVersion}
                />
              </SaveDropdownStyles>
            )}

            <SaveDropdownStyles className='panel-icon-dropdown share-dropdown'>
              <ShareDropdown
                exportEnabled={exportEnabled}
                vizIsEmpty={this.props.vizIsEmpty}
                onCopyLink={() => this.doAction('share')}
                onDownload={() => this.doAction('download')}
                vizId={this.props.id}
                onChangeAccess={access => this.doAction(access)}
                chartIsValid={this.props.chartIsValid}
                isNewViz={this.props.isNewViz}
                isPrivate={this.props.isPrivate}
                isUserOwner={this.props.isUserOwner}
                isDisabled={!this.props.chartIsValid && isSharedDisabled}
                shouldExportAsExcel={shouldExportAsExcel}
                chartType={this.props.viz.chartType}
              />
            </SaveDropdownStyles>

            {pinPanelItems}
          </Tabs>
        </div>
      </DiscoveryToolbarNavbar>
    );
  }
}

const isPinnedSelector: (state: any, props?: any) => any = createSelector(
  [VIZ_SELECTORS.getDiscoveryId, ACCOUNT_SELECTORS.getPinnedDiscoveries],
  (id, pinned: string[]) => {
    if (_.isEmpty(pinned)) {
      return false;
    } else {
      return pinned.some(pinnedId => pinnedId === id);
    }
  },
);

const mapStateToProps = (state, ownProps): IDiscoveryToolbarMapStateProps => {
  const discovery =
    state.discover.openDiscoveries[state.discover.displayDiscovery];
  const { vizIsEmpty } = state.discover;
  const open = discovery.present;
  const { dirty = false } = open ?? {};
  const chartSpec = ChartSpecs[open?.viz?.chartType];
  const chartIsValid =
    isFunction(chartSpec?.validate) && chartSpec.validate(open.viz).valid;
  const isAdvancedMode = state.main.advanced;
  const useFiscalCalendar =
    (VIZ_SELECTORS.getActiveVizFiscalSetting as any)(state, ownProps) ===
    'true';

  const useLiveQuery = (VIZ_SELECTORS.getLiveQueryOption as any)(
    state,
    ownProps,
  );

  const leftPanelWidth = (VIZ_SELECTORS.getActiveVizPanelWidth as any)(
    state,
    ownProps,
  );
  const { dateFormat, timeFormat } =
    ACCOUNT_SELECTORS.getDatetimeFormats(state);
  const { i18nPrefs = {} } = state?.account?.currentUser;
  const configPanelDetail = getConfigPanelDetail(state, {
    discoveryId: discovery?.viz?.id,
  });
  const isNewViz = !!open?.id?.includes('newViz');
  return {
    dateFormat,
    timeFormat,
    discovery: open,
    chartSpec,
    allowedTabs: getAllowedTabs(state),
    configPanelDetail: open ? configPanelDetail : null,
    interactivePanelDetail: open?.viz?.options
      ? open.viz.options[VIZ_OPTION_IDS.panelDetail]
      : null,
    id: state.discover.displayDiscovery,
    hasUndo: open && discovery?.past?.length > 0,
    hasRedo: open && discovery?.future?.length > 0,
    isMobile: state.main.isMobile,
    useLiveQuery,
    vizIsEmpty,
    chartIsValid,
    isNewViz,
    isAdmin: isAdmin(state.account),
    isPrivate: isPrivate(state),
    isReadOnlyUser: getIsReadOnlyUser(state),
    isUserOwner: isUserOwnerOfDiscoveryViz(state) || isAdmin(state.account),
    isAdvancedMode,
    userPreferences: (ACCOUNT_SELECTORS.getUserPreferences as any)(
      state,
      ownProps,
    ),
    isPinned: isPinnedSelector(state, {}),
    viz: open?.viz,
    queryResults: _.get(open, 'vizQueryResults.data'),
    hasFiscalCalendarSetting: (
      VIZ_SELECTORS.hasVizDatasetFiscalCalendarSetting as any
    )(state, ownProps),
    leftPanelWidth,
    useFiscalCalendar,
    i18nPrefs,
    dirty,
    canSaveVersion:
      !isNewViz &&
      (open?.viz?.canUpdate ?? true) &&
      (dirty ||
        _.isEmpty(open?.viz?.revisions) ||
        !_.isEqual(
          (_.head(open?.viz?.revisions) as IRevision)?.updatedOn,
          open?.viz?.updatedOn,
        )),
  };
};
let toastTimer;
const mapDispatchToProps = (
  dispatch,
): IDiscoveryToolbarDispatchProps & IUserPreferencesMutationInputProps => {
  return {
    setPanelDetail: (discovery: IDiscovery, panelKey) => {
      dispatch(Discover.setPanelDetail(discovery?.viz.id, panelKey));
    },
    setConfigPanelDetail: (discovery: IDiscovery, panelKey) => {
      dispatch(Discover.setConfigPanelDetail(discovery?.viz?.id, panelKey));
    },
    share: (discovery: IDiscovery) => {
      dispatch(MainActions.copyToClipboard(window.location.href));
      dispatch(
        MainActions.showToast({
          text: messages.linkCopied,
          id: discovery?.viz?.id,
        }),
      );
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        dispatch(MainActions.closeToast());
      }, 2000);
    },
    undo: (discovery: IDiscovery) => {
      dispatch(Discover.undoDiscovery(discovery?.viz?.id));
    },
    redo: (discovery: IDiscovery) => {
      dispatch(Discover.redoDiscovery(discovery?.viz?.id));
    },
    refresh: (discovery: IDiscovery) => {
      const variables = Viz.buildQueryVariables(discovery?.viz);

      dispatch(
        Discover.vizQuery({
          id: discovery?.viz?.id,
          variables: {
            ...variables,
            bypassCache: true,
          },
        }),
      );
    },
    setVizAccess: (discovery: IDiscovery, access) => {
      dispatch(Discover.setVizAccess(discovery?.viz?.id, access));
    },
    refreshUserPreferences: userPrefs => {
      dispatch(Account.setCurrentUserPreferences(userPrefs));
    },
    setUsingFiscalCalendar: (discovery: IDiscovery, useFiscalCalendar) => {
      dispatch(
        Discover.setSettingForViz({
          id: discovery?.viz?.id,
          setting: USE_FISCAL_REPORTING,
          value: useFiscalCalendar,
        }),
      );
    },
    setUsingLiveQuery: (discovery: IDiscovery, useLiveQuery) => {
      dispatch(
        Discover.setLiveQueryForViz({
          id: discovery?.viz?.id,
          value: useLiveQuery,
        }),
      );
    },
    setDirtyViz: (vizId, dirty = true) => {
      dispatch(Discover.setDiscoveryDirty(vizId, dirty));
    },
  };
};

export interface ICreateTargetMutationProps {
  createTarget: any;
}

export const DiscoveryToolbar = compose(
  ToastHOC,
  connect(mapStateToProps, mapDispatchToProps),
  UserPreferencesMutation,
  withTheme,
)(
  DiscoveryToolbarUnconnected as any,
) as ComponentClass<IDiscoveryToolbarOwnProps>;
